import { render, staticRenderFns } from "./ContactUsView.vue?vue&type=template&id=b5e0c2e6&scoped=true"
import script from "./ContactUsView.vue?vue&type=script&lang=ts"
export * from "./ContactUsView.vue?vue&type=script&lang=ts"
import style0 from "./ContactUsView.vue?vue&type=style&index=0&id=b5e0c2e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e0c2e6",
  null
  
)

export default component.exports